import { PartOfCampaignInfo } from '../PartOfCampaignInfo/PartOfCampaignInfo'
import { usePublicFundraiserConfig } from '../../hooks'

import { Box, Spacer } from '@percent/lemonade'
import { DescriptionProps } from './Description.types'
import { TitleAndStory } from './TitleAndStory/TitleAndStory'
import { HeroImage } from './HeroImage/HeroImage'
import { Tags } from './Tags/Tags'
import { FeaturedBadge } from './FeaturedBadge/FeaturedBadge'
import { PublicBadge } from './PublicBadge/PublicBadge'
import { UnlistedBadge } from './UnlistedBadge/UnlistedBadge'
import { BadgesContainer } from './BadgesContainer/BadgesContainer'

export function Description({
  image,
  name,
  story,
  tags,
  location,
  startDate,
  entityName,
  relatedCampaign,
  featured,
  campaignBannerAsBacklink = false,
  visibility,
  isUnlisted = false,
  unlistedEntityType
}: Readonly<DescriptionProps>) {
  const hasFundraiserBadges = featured || visibility === 'public'
  const { publicFundraiserEnabled } = usePublicFundraiserConfig()

  return (
    <Box data-testid="description-details">
      <HeroImage image={image} />
      <Spacer size={8} axis="vertical" />
      {hasFundraiserBadges && (
        <BadgesContainer testId="fundraiser-badges">
          {featured && <FeaturedBadge featured={featured} />}
          {visibility === 'public' && publicFundraiserEnabled && <PublicBadge />}
        </BadgesContainer>
      )}
      {(tags || (isUnlisted && unlistedEntityType)) && (
        <Tags highlightFirstTag tags={tags}>
          {isUnlisted && unlistedEntityType && <UnlistedBadge entityType={unlistedEntityType} />}
        </Tags>
      )}
      {relatedCampaign ? (
        <PartOfCampaignInfo
          entityName={entityName}
          campaign={relatedCampaign}
          navigateReplace={campaignBannerAsBacklink}
        />
      ) : null}
      <TitleAndStory name={name} story={story} location={location} startDate={startDate} />
    </Box>
  )
}
